export default __webpack_public_path__ + "static/media/AfterOf.2c19fcc4.svg";